/* eslint-disable react/no-array-index-key */
import { Typography, Collapse, IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { AdminTestContext } from '@orientaction/Context';
import { useContext, useState } from 'react';
import { getNextId } from '../../utils';
import Board from '../WithDragAndDrop';
import NoQuestion from './NoQuestion';
import style from './style';

const QuestionsSection = () => {
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const [isExpanded, setIsExpanded] = useState(true);

  const classes = style();

  const handleClick = () => {
    const id = Math.random().toString(36).substr(2, 9);
    updateTest({
      questionDrawerOpen: true,
      questionToCreate: {
        id,
        title: '',
        index: test?.questions?.length,
        responses: [],
        responseType: 'text',
        type: 'create',
        isNew: true,
        mediaUrl: '',
        mediaType: 'none'
      },
    });
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginTop: 35, marginBottom: 15 }}>
        <div className={classes.sectionTitle} onClick={() => setIsExpanded(!isExpanded)}>
          <Typography component="h1" style={{ color: '#FFFFFF', fontSize: 20, fontWeight: 700, fontFamily: 'Poppins' }}>
            Questionnaire
          </Typography>
          <IconButton style={{ color: '#FFFFFF', padding: '4px' }}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
      </div>
      
      <Collapse in={isExpanded}>
        {test?.questions?.length ? <Board /> : <NoQuestion hasError={test?.errors?.questions} />}
        <div className={classes.flexContainer}>
          <Button onClick={handleClick} className={classes.btnPrimary}>
            <span className={classes.textHeader}>Ajouter une question</span>
          </Button>
        </div>
      </Collapse>
    </div>
  );
};

export default QuestionsSection;
